module.exports = __webpack_public_path__ + "static/img/contactus-pic.def80cde.jpg";